export default __webpack_public_path__ + "img/img_2.79a16aad.png";